<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>
            Mark Client as
            @if (client.status) {
                active
            } @else {
                inactive
            }
        </cll-dialog-title>
        <cll-dialog-subtitle>{{ client.person.given_name }} {{ client.person.family_name }}</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <cll-panel-tonal colour="info">
                <cll-icon cllPanelIcon>info</cll-icon>
                <div class="panel-text-group">
                    @if (!client.status) {
                        <span class="panel-text-header">Mark as inactive</span>
                    } @else {
                        <span class="panel-text-header">Mark as active</span>
                    }
                </div>
            </cll-panel-tonal>
            <span>Are you sure you want to proceed?</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (updateClientRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="this.updateClientRequest.loading()"
                (click)="update()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
